import { useEffect, useRef } from "react";
import { fetchClient } from "@/lib/api-client";
import { BLOG_SITE } from "@/lib/blog/site";

/** Fires a best-effort view increment once per slug mount. */
export const useIncrementBlogView = (slug: string | undefined) => {
  const fired = useRef<string | null>(null);
  useEffect(() => {
    if (!slug || fired.current === slug) return;
    fired.current = slug;
    fetchClient
      .POST("/blog/{slug}/view", {
        params: { path: { slug }, query: { site: BLOG_SITE } },
      })
      .catch(() => {});
  }, [slug]);
};
